export default __webpack_public_path__ + "static/media/status_2.ed17b745.png";